export default {
  pager: (state) => state.pager,
  isChecked: (state) => state.isChecked,
  blob: (state) => state.blob,
  blobs: (state) => state.blobs,
}
